import { NavLink } from 'react-router-dom'

const TABS = [
  { to: '/app/feeds', label: 'Destinations', end: true },
  { to: '/app/feeds/items', label: 'Items' },
  { to: '/app/feeds/rooms', label: 'Rooms & Sets' },
  { to: '/app/feeds/proposals', label: 'Proposals' },
]

export function FeedsNav() {
  return (
    <nav className="flex flex-wrap gap-1 border-b">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-3 py-2 text-sm ${
              isActive ? 'border-slate-900 font-medium text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-800'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}

/** Page frame for the Feeds section: title, one line of explanation, the tabs. */
export function FeedsFrame({ title, description, children }: { title: string; description: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="space-y-6 p-6">
      <div className="space-y-3">
        <div>
          <h1 className="text-2xl font-semibold">{title}</h1>
          <p className="max-w-4xl text-sm text-slate-500">{description}</p>
        </div>
        <FeedsNav />
      </div>
      {children}
    </div>
  )
}

export const num = (v: number | null | undefined) => (v == null ? '—' : v.toLocaleString())

export function duration(ms: number | null | undefined) {
  if (ms == null) return '—'
  const s = Math.round(ms / 1000)
  if (s < 60) return `${s}s`
  const m = Math.floor(s / 60)
  return `${m}m ${String(s % 60).padStart(2, '0')}s`
}

const TONE: Record<string, string> = {
  green: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  amber: 'bg-amber-50 text-amber-800 border-amber-200',
  red: 'bg-red-50 text-red-800 border-red-200',
  slate: 'bg-slate-50 text-slate-700 border-slate-200',
  blue: 'bg-sky-50 text-sky-800 border-sky-200',
}

export function Pill({ tone, children, title }: { tone: keyof typeof TONE; children: React.ReactNode; title?: string }) {
  return (
    <span title={title} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONE[tone]}`}>
      {children}
    </span>
  )
}

export function BuildStatus({ status }: { status: string }) {
  if (status === 'done') return <Pill tone="green">done</Pill>
  if (status === 'failed') return <Pill tone="red">failed</Pill>
  return <Pill tone="blue">running</Pill>
}
